import { combineReducers } from "redux";

import { generateCrudRedux, ICRUDReduxState } from "../../../../core/redux";
import { IExpense, IExpenseForm } from "../../data/entities";
import { ExpenseRepoImpl } from "../../data/repo";

export const expenseRedux = generateCrudRedux<IExpense, IExpenseForm>({
  actionTypeName: "Expense",
  repository: ExpenseRepoImpl,
});

export interface IExpenseReduxState extends ICRUDReduxState<IExpense> {}

export const ExpenseReducers = combineReducers<IExpenseReduxState>({
  ...expenseRedux.reducer,
});
